import MainView from 'js/views/main';
import { inferTimezone } from 'pmn/utils/dateTime';

export default class View extends MainView {
  mount(): void {
    super.mount();
    const id = 'user_novena_invite_timezone';
    const field = document.getElementById(id);
    if (field) {
      (field as HTMLInputElement).value = inferTimezone();
    }
  }

  unmount(): void {
    super.unmount();
  }
}
